export default function OperationsSkeleton() {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse">
      {/* ═══ 4-CARD OPERATIONAL SUMMARY BAR (h-28) ═══ */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="h-28 bg-card-dark rounded-xl border border-card-border p-5 flex flex-col justify-between"
          >
            <div className="flex items-center justify-between">
              <div className="h-3.5 w-28 bg-white/[.06] rounded" />
              <div className="w-6 h-6 rounded-md bg-white/[.06]" />
            </div>
            <div className="flex items-baseline justify-between">
              <div className="h-7 w-28 bg-white/[.08] rounded" />
              <div className="h-3.5 w-16 bg-white/[.04] rounded" />
            </div>
          </div>
        ))}
      </div>

      {/* ═══ VISUAL CHARTS ROW (h-[380px]) ═══ */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Capacity vs Duration Scatter Matrix */}
        <div className="h-[380px] bg-card-dark rounded-xl border border-card-border p-5 flex flex-col">
          <div className="flex items-center justify-between pb-3 border-b border-card-border">
            <div className="flex items-center gap-2">
              <div className="h-5 w-48 bg-white/[.08] rounded" />
              <div className="h-4 w-16 bg-white/[.04] rounded-full" />
            </div>
            <div className="flex items-center gap-2">
              <div className="h-6 w-20 bg-white/[.05] rounded" />
            </div>
          </div>
          <div className="flex-1 mt-4 rounded-lg bg-white/[.02] flex items-center justify-center relative overflow-hidden">
            <div className="w-full h-full flex flex-col justify-around px-8 opacity-30">
              <div className="h-[1px] w-full bg-white/10" />
              <div className="h-[1px] w-full bg-white/10" />
              <div className="h-[1px] w-full bg-white/10" />
              <div className="h-[1px] w-full bg-white/10" />
            </div>
          </div>
        </div>

        {/* Queue Slippage & CapEx Radar */}
        <div className="h-[380px] bg-card-dark rounded-xl border border-card-border p-5 flex flex-col">
          <div className="flex items-center justify-between pb-3 border-b border-card-border">
            <div className="flex items-center gap-2">
              <div className="h-5 w-44 bg-white/[.08] rounded" />
              <div className="h-4 w-20 bg-white/[.04] rounded-full" />
            </div>
            <div className="h-6 w-24 bg-white/[.05] rounded" />
          </div>
          <div className="flex-1 mt-4 rounded-lg bg-white/[.02] flex items-center justify-center relative overflow-hidden">
            <div className="w-full h-full flex flex-col justify-around px-8 opacity-30">
              <div className="h-[1px] w-full bg-white/10" />
              <div className="h-[1px] w-full bg-white/10" />
              <div className="h-[1px] w-full bg-white/10" />
              <div className="h-[1px] w-full bg-white/10" />
            </div>
          </div>
        </div>
      </div>

      {/* ═══ BESS ROUND-TRIP EFFICIENCY (RTE) & DEGRADATION SKELETON (h-[340px]) ═══ */}
      <div className="h-[340px] bg-card-dark rounded-xl p-5 flex flex-col justify-between">
        <div className="flex items-center justify-between pb-3 border-b border-card-border">
          <div className="flex items-center gap-2">
            <div className="h-5 w-56 bg-white/[.08] rounded" />
            <div className="h-4 w-28 bg-white/[.04] rounded-full" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-6 w-24 bg-white/[.05] rounded" />
            <div className="h-6 w-20 bg-white/[.05] rounded" />
          </div>
        </div>
        <div className="flex-1 my-3 rounded-lg bg-white/[.02] flex items-center justify-center relative overflow-hidden">
          <div className="w-full h-full flex flex-col justify-around px-8 opacity-30">
            <div className="h-[1px] w-full bg-white/10" />
            <div className="h-[1px] w-full bg-white/10" />
            <div className="h-[1px] w-full bg-white/10" />
          </div>
        </div>
        <div className="flex items-center justify-between pt-2 border-t border-card-border">
          <div className="h-3 w-48 bg-white/[.04] rounded" />
          <div className="h-3 w-32 bg-white/[.04] rounded" />
        </div>
      </div>

      {/* ═══ DENSE FINANCIAL ASSET TABLE (h-[420px]) ═══ */}
      <div className="h-[420px] bg-card-dark rounded-xl border border-card-border overflow-hidden flex flex-col">
        {/* Table Toolbar */}
        <div className="px-4 py-3 border-b border-card-border flex items-center justify-between bg-card-dark shrink-0">
          <div className="flex items-center gap-2">
            <div className="h-8 w-24 bg-white/[.06] rounded-lg" />
            <div className="h-8 w-28 bg-white/[.04] rounded-lg" />
          </div>
          <div className="flex items-center gap-3">
            <div className="h-8 w-24 bg-white/[.04] rounded-lg" />
            <div className="h-8 w-60 md:w-76 bg-white/[.04] rounded-lg" />
          </div>
        </div>

        {/* Table Header */}
        <div className="grid grid-cols-7 gap-4 px-5 py-3 border-b border-card-border bg-card-dark/95">
          <div className="h-3.5 w-24 bg-white/[.06] rounded" />
          <div className="h-3.5 w-16 bg-white/[.06] rounded" />
          <div className="h-3.5 w-20 ml-auto bg-white/[.06] rounded" />
          <div className="h-3.5 w-20 ml-auto bg-white/[.06] rounded" />
          <div className="h-3.5 w-16 ml-auto bg-white/[.06] rounded" />
          <div className="h-3.5 w-16 bg-white/[.06] rounded" />
          <div className="h-3.5 w-20 ml-auto bg-white/[.06] rounded" />
        </div>

        {/* Table Rows (6 rows matching ~420px total height) */}
        <div className="divide-y divide-card-border flex-1 overflow-hidden">
          {[1, 2, 3, 4, 5, 6].map((row) => (
            <div key={row} className="grid grid-cols-7 gap-4 px-5 py-3.5 items-center">
              <div className="h-3.5 rounded bg-white/[.06]" style={{ width: `${60 + (row % 3) * 15}%` }} />
              <div className="h-3.5 w-14 rounded bg-white/[.04]" />
              <div className="h-3.5 w-16 ml-auto rounded bg-white/[.04]" />
              <div className="h-3.5 w-16 ml-auto rounded bg-white/[.04]" />
              <div className="h-3.5 w-12 ml-auto rounded bg-white/[.04]" />
              <div className="h-5 w-20 rounded-full bg-white/[.05]" />
              <div className="h-3.5 w-20 ml-auto rounded bg-white/[.04]" />
            </div>
          ))}
        </div>
      </div>

      {/* ═══ EPA ENVIRONMENTAL COMPLIANCE MODULE (h-[260px]) ═══ */}
      <div className="h-[260px] bg-card-dark rounded-xl border border-card-border p-5 flex flex-col justify-between">
        <div className="flex items-center justify-between pb-3 border-b border-card-border">
          <div className="flex items-center gap-2">
            <div className="h-5 w-56 bg-white/[.08] rounded" />
            <div className="h-4 w-24 bg-white/[.04] rounded-full" />
          </div>
          <div className="h-6 w-28 bg-white/[.05] rounded" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 flex-1 mt-4">
          <div className="rounded-lg bg-white/[.02] p-4 flex flex-col justify-between">
            <div className="h-3.5 w-24 bg-white/[.06] rounded" />
            <div className="h-6 w-20 bg-white/[.08] rounded" />
            <div className="h-3 w-32 bg-white/[.04] rounded" />
          </div>
          <div className="rounded-lg bg-white/[.02] p-4 flex flex-col justify-between">
            <div className="h-3.5 w-28 bg-white/[.06] rounded" />
            <div className="h-6 w-16 bg-white/[.08] rounded" />
            <div className="h-3 w-28 bg-white/[.04] rounded" />
          </div>
          <div className="rounded-lg bg-white/[.02] p-4 flex flex-col justify-between">
            <div className="h-3.5 w-28 bg-white/[.06] rounded" />
            <div className="h-6 w-12 bg-white/[.08] rounded" />
            <div className="h-3 w-36 bg-white/[.04] rounded" />
          </div>
        </div>
      </div>
    </div>
  );
}
